import { storage } from '@b2x/std/core/storage.mjs';

import type { ActionFlow } from '@/types';
import { logger } from '@/utilities/logger';

const log = logger.createLogger('FLOW');

const standardFlow: ActionFlow = ['declarationOfConsent', 'checkForConsentUpdates'];

const natconFlow: ActionFlow = ['checkForConsentUpdates'];

const marketFlows: Record<string, null | ActionFlow> = {
  hk: natconFlow,
  jp: natconFlow,
  kr: natconFlow,
  la: natconFlow,
  mo: natconFlow,
  my: natconFlow,
  sg: natconFlow,
  standard: standardFlow,
};

export function getMarketFlow(market: string) {
  const customFlow = storage.local.get('b2x.lal_flow');

  if (customFlow) {
    log.warn('Using custom flow', customFlow);

    return customFlow as ActionFlow;
  }

  return marketFlows[market] || (marketFlows.standard as ActionFlow);
}
